import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material';
import { EmptyStateView } from './EmptyStateView';

interface TableStatusViewProps {
  isLoading?: boolean;
  hasNoRecords: boolean;
  colCount: number;
}

const ARBITRARY_NUMBER_OF_LOADING_ROWS = 4;

function LoadingRows({ rows = ARBITRARY_NUMBER_OF_LOADING_ROWS, columns }: { rows?: number; columns: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_row, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((_col, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton variant='rectangular' width={120} height={20} sx={{ borderRadius: '8px' }} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default function TableStatusView({ isLoading, hasNoRecords, colCount = 6 }: TableStatusViewProps) {
  return (
    <TableBody>
      {!isLoading && hasNoRecords && (
        <TableRow>
          <TableCell className='text-center' colSpan={colCount}>
            <EmptyStateView />
          </TableCell>
        </TableRow>
      )}
      {isLoading && <LoadingRows columns={colCount} />}
    </TableBody>
  );
}
